import PropTypes from 'prop-types';
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useReducer,
} from 'react';

import { inAuthWidget } from '../../routes/Root';
import actions from './actions';
import reducer from './reducer';

const initialState = {
  networkDetails: {
    unsavedChanges: false,
    loading: false,
    data: [],
    error: {},
  },
};

const UpgradeContext = createContext(undefined);

export function UpgradeProvider({ children }) {
  const [newState, dispatch] = useReducer(reducer, initialState);
  const {
    networkDetails: { data },
  } = newState;
  const newActions = useMemo(() => actions(dispatch), [dispatch]);

  useEffect(() => {
    if (inAuthWidget) return;
    const hasUnsavedChanges = data.some(({ id }) => {
      return new RegExp(/^new-|deleted-|edited-/gm).test(id);
    });

    newActions.setUnsavedChanges(hasUnsavedChanges);
  }, [data]);

  return (
    <UpgradeContext.Provider
      value={[newState, newActions]}
      displayName="UpgradeContext"
    >
      {children}
    </UpgradeContext.Provider>
  );
}

export const useUpgradeContext = () => {
  const context = useContext(UpgradeContext);

  if (!context) {
    throw new Error('useUpgradeContext must be used within UpgradeProvider');
  }
  return context;
};

UpgradeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
